/** First stored path from semicolon-separated {@code item.photo} value. */
export function firstListingPhotoPath(photo: string | null | undefined): string | null {
  if (!photo) {
    return null;
  }
  for (const part of photo.split(';')) {
    const trimmed = part.trim();
    if (trimmed) {
      return trimmed.startsWith('/') ? trimmed : `/${trimmed}`;
    }
  }
  return null;
}

/** Full thumbnail URL for browse cards (first photo only). */
export function listingThumbnailUrl(
  imagesBase: string | null | undefined,
  photo: string | null | undefined
): string {
  const path = firstListingPhotoPath(photo);
  if (!path) {
    return '';
  }
  const base = (imagesBase || '').replace(/\/+$/, '');
  return `${base}${path}`;
}
